import { Field } from '@shared/data/entity/fields/Field';

interface Props {
  field?: Field | null;
}

export function UnknownCollectionViewField({ field }: Props) {
  console.warn('Field type not supported in this view.', field);
  return null;
}
